import { css } from "@emotion/css";
import styled from "@emotion/styled";

import { Flexbox } from "../../shared/components";

export const OrangeLine = styled.div`
    position: absolute;
    top: 0;

    width: 100%;
    height: 2px;

    background: #ffd301;
`;

export const NavigationContainer = styled(Flexbox)`
    height: 100%;
    padding: 8px 36px;
`;

export const NavigationBox = styled(Flexbox)`
    flex: 1;
`;

export const topNavigationHeight = "56px";

export const ghostImageContainer = css`
    padding: 8px;
    line-height: 0;
`;

export const ghostImage = css`
    width: 24px;
    height: 24px;
`;
